import React from "react";
import { Button, DownloadIcon } from "@pd/pd-ui-kit";
import { useHistory } from "react-router-dom";

import { useGetIvideonLicensesReport } from "~/entity/Ivideon";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import s from "./../RegisterOfDocuments.less";

const TitleNavigateGroup = ({getLicensesReport}:{ getLicensesReport:boolean}) => {
  const history = useHistory();
  const { getIvideonLicensesReport } = useGetIvideonLicensesReport();
  const currentDealerId = useCurrentDealerId();
  const goDealersRegistry = () => {
    history.push("/ivideon/dealers/");
  };

  const goIvideon = () => {
    history.push(
      `/ivideon/dealers/${currentDealerId}`,
    );
  };

  return (
    <div className={s.navigateButtons}>
      {getLicensesReport && (
        <Button
          bold={true}
          color="primary"
          fontSize="12"
          icon={<DownloadIcon size={16} fill="#ffffff" viewBox="0 0 16 16" />}
          iconPosition="end"
          onClick={() => getIvideonLicensesReport()}
          radius="5"
          size="middle"
          transform="none"
        >
          Лицензии
        </Button>
      )}
      <Button
        bold={true}
        color="secondary"
        variant="filled"
        fontSize="12"
        onClick={goDealersRegistry}
        radius="5"
        size="middle"
        transform="none"
      >
        Реестр дилеров
      </Button>
      <Button
        bold={true}
        color="secondary"
        variant="filled"
        fontSize="12"
        onClick={goIvideon}
        radius="5"
        size="middle"
        transform="none"
      >
        Зоны просмотра IVIDEON
      </Button>
    </div>
  );
};

export default TitleNavigateGroup;
